import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Lobby from './views/Lobby'
import TeamView from './views/TeamView'
import FacilitatorView from './views/FacilitatorView'
import MySessions from './views/MySessions'
import Header from './components/Header'
import { useAuthStore } from './store/auth'
import * as api from './api/client'

export default function App() {
  const setUser = useAuthStore((s) => s.setUser)
  const setLoading = useAuthStore((s) => s.setLoading)

  // Hydrate auth state from the server cookie on mount. Single fetch — the
  // store stays the source of truth for the rest of the session.
  useEffect(() => {
    let cancelled = false
    setLoading(true)
    api.getMe()
      .then((user) => { if (!cancelled) setUser(user) })
      .catch(() => { if (!cancelled) setUser(null) })
    return () => { cancelled = true }
  }, [setUser, setLoading])

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Lobby />} />
        <Route path="/sessions" element={<MySessions />} />
        <Route path="/session/:sessionId/join" element={<Lobby />} />
        <Route path="/team/:sessionId/:teamId" element={<TeamView />} />
        <Route path="/facilitator/:sessionId" element={<FacilitatorView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}
